import apiClient from "../api/axios";
import {
  GetCitiesResponse,
  GetDistrictsResponse,
  GetSubdistrictsResponse,
  GetSubdistrictResponse,
  GetFullSubdistrictsResponse,
  City,
  District,
  Subdistrict,
  FullLocation,
} from "../models/location.types";

const LOCATION_BASE_URL = "/v1/locations";

/** GET /v1/locations/cities
 *  response.data.results = City[]
 */
export const getLocationCities = async (): Promise<City[]> => {
  try {
    const response = await apiClient.get<GetCitiesResponse>(
      `${LOCATION_BASE_URL}/cities`,
    );
    return response.data.results;
  } catch (error) {
    throw error;
  }
};

/** GET /v1/locations/cities/:cityRefId/districts
 *  response.data.results = District[]
 */
export const getDistrictsByCity = async (cityRefId: string): Promise<District[]> => {
  try {
    const response = await apiClient.get<GetDistrictsResponse>(
      `${LOCATION_BASE_URL}/cities/${cityRefId}/districts`,
    );
    return response.data.results;
  } catch (error) {
    throw error;
  }
};

/** GET /v1/locations/districts/:districtRefId/subdistricts
 *  response.data.results = Subdistrict[]
 */
export const getSubdistrictsByDistrict = async (districtRefId: string): Promise<Subdistrict[]> => {
  try {
    const response = await apiClient.get<GetSubdistrictsResponse>(
      `${LOCATION_BASE_URL}/districts/${districtRefId}/subdistricts`,
    );
    return response.data.results;
  } catch (error) {
    throw error;
  }
};

/** GET /v1/locations/subdistricts/:subdistrictRefId
 *  response.data.results = FullLocation (object เดียว)
 */
export const getLocationBySubdistrict = async (subdistrictRefId: string): Promise<FullLocation> => {
  try {
    const response = await apiClient.get<GetSubdistrictResponse>(
      `${LOCATION_BASE_URL}/subdistricts/${subdistrictRefId}`,
    );
    return response.data.results;
  } catch (error) {
    throw error;
  }
};

/** GET /v1/locations/postal-codes/:postalCode/subdistricts
 *  response.data.results = FullLocation[]
 */
export const getSubdistrictsByPostalCode = async (postalCode: string): Promise<FullLocation[]> => {
  try {
    const response = await apiClient.get<GetFullSubdistrictsResponse>(
      `${LOCATION_BASE_URL}/postal-codes/${postalCode}/subdistricts`,
    );
    return response.data.results;
  } catch (error) {
    throw error;
  }
};